
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.937 15.203c0 .61-.476 1.106-1.063 1.106-.586 0-1.062-.495-1.062-1.106v-2.55H3.442v2.55c0 .61-.475 1.106-1.063 1.106-.586 0-1.062-.495-1.062-1.106v-2.55c0-1.221.951-2.211 2.125-2.211h17.37c1.174 0 2.125.99 2.125 2.21V15.204zM19.749 20.39c0 1.22.952 2.21 2.126 2.21 1.173 0 2.125-.99 2.125-2.21 0-1.221-.952-2.21-2.125-2.21-1.174 0-2.126.989-2.126 2.21zM10.187 20.39c0 1.22.951 2.21 2.125 2.21s2.126-.99 2.126-2.21c0-1.221-.952-2.21-2.126-2.21s-2.125.989-2.125 2.21zM10.187 3.81c0 1.22.951 2.21 2.125 2.21s2.126-.99 2.126-2.21-.952-2.21-2.126-2.21-2.125.99-2.125 2.21zM.623 20.39c0 1.22.952 2.21 2.125 2.21 1.174 0 2.126-.99 2.126-2.21 0-1.221-.952-2.21-2.126-2.21-1.173 0-2.125.989-2.125 2.21z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M13.374 15.745c0 .611-.475 1.106-1.062 1.106-.587 0-1.063-.495-1.063-1.105v-6.41c0-.61.476-1.105 1.063-1.105s1.062.495 1.062 1.106v6.409-.001z","fill":"currentColor"}})])
          )
        }
      }
    